import tour9Gif from '../../../assets/images/tour-images/tour-9.gif';
import tour11Gif from '../../../assets/images/tour-images/tour-11.gif';
import tour12Gif from '../../../assets/images/tour-images/tour-12.gif';

export const tourText = {
  libraryOverview: {
    title: 'Your library',
    description:
      'Upload and organise your media in one place. Your files are instantly available across videos, microlessons, and courses—ready whenever you need them. Supports images, videos, and audio formats.',
    image: tour9Gif,
  },
  libraryUpload: {
    title: 'Upload files',
    description: 'Click here to upload new files.',
  },
  librarySearch: {
    title: 'Search library',
    description: 'Find files quickly using the search.',
  },
  libraryFilters: {
    title: 'Filter by type',
    description:
      'Narrow your library to documents, images, videos, AI-generated videos, or audio with a single click.',
  },
  librarySort: {
    title: 'Sort your files',
    description:
      'Reorder the list — for example by upload date or name — to find what you need faster.',
    image: tour12Gif,
  },
  libraryCardOptions: {
    title: 'File actions',
    description:
      'Open this menu on any file card to preview, edit, download, or delete the asset.',
    image: tour11Gif,
  },
};
